export default "__VITE_ASSET__7l4Sbwhr__"